import { Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import {
  makeSelectAccountSlug,
  makeSelectSelectedAccountSlug,
  makeSelectWhoami,
} from 'containers/Auth_old/selectors';
import { usePostHog } from 'hooks/usePostHog';

import { buildKnowledgeBaseLink } from './knowledgeBaseDeepLink';
import { messages } from './messages';

const useStyles = makeStyles(theme => ({
  row: {
    ...theme.typography.body2,
    fontWeight: theme.typography.button.fontWeight,
    color: 'var(--ds-color-primary)',
    height: 36,
    padding: theme.spacing(0.75, 1),
    marginTop: theme.spacing(-1.25),
    whiteSpace: 'nowrap',
  },
  panel: {
    height: 40,
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.misc.borderRadius,
  },
}));

export const EditKnowledgeBaseButton = ({
  agentId,
  surface,
}: {
  agentId: string;
  surface: 'row' | 'panel';
}) => {
  const whoami = useSelector(makeSelectWhoami());
  const accountSlug = useSelector(makeSelectAccountSlug()) ?? '';
  const selectedAccountSlug = useSelector(makeSelectSelectedAccountSlug());
  const history = useHistory();
  const location = useLocation();
  const posthog = usePostHog();
  const intl = useIntl();
  const classes = useStyles();

  if (!whoami.policies?.manage_account) return null;

  return (
    <Button
      color="primary"
      variant={surface === 'row' ? 'text' : 'contained'}
      className={classes[surface]}
      onClick={event => {
        event.stopPropagation();
        posthog.capture('candidate_ai_agent:conversations_edit_kb_click', {
          agent_id: agentId,
        });
        history.push(
          buildKnowledgeBaseLink(
            selectedAccountSlug || accountSlug,
            agentId,
            location.pathname + location.search,
          ),
        );
      }}
    >
      {intl.formatMessage(messages.editKnowledgeBase)}
    </Button>
  );
};
